import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/thanks.css";

export default function Thanks() {
  return (
    <div className="thanks">
      <Header />
      <div className="thanks-body">
        <div className="thanks-container">
          <div className="thanks-text">
            <h1>Thank You!</h1>
            <h2>
              Your donation helps us maintain and improve our service for all Hokies
            </h2>
            <Link to="/" className="primary-button">
              Return to Home
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
